import { AnyAction } from 'redux';
import { MyDocumentsActions, MyDocumentsItem, MyDocumentsState } from './my-documents-models';


const initialState: MyDocumentsState =
{
	documents: null,
	contentLoaded: false,	
};

export const myDocumentsReducer = (state = initialState, action: AnyAction): MyDocumentsState => {

	switch (action.type) {
		
		case MyDocumentsActions.SET_MY_DOCUMENTS_LIST:
			return {
				...state,			
				documents: action.payload,	
				contentLoaded: true,
			};
		default: return state;
	}
};

export const setMyDocuments = (documents: MyDocumentsItem[]) => {

	return {
		type: MyDocumentsActions.SET_MY_DOCUMENTS_LIST,
		payload: documents,
	};
};
